import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-vendor-detail-modal',
  templateUrl: './vendor-detail-modal.component.html',
  styleUrls: ['./vendor-detail-modal.component.css']
})
export class VendorDetailModalComponent {

  @Input() vendorDetail: any;
  @Output() closeModal = new EventEmitter<any>();

  onCloseModal() {
    this.closeModal.emit();
  }

}
